import { render, staticRenderFns } from "./BroadcastStats.vue?vue&type=template&id=20311a72&"
import script from "./BroadcastStats.vue?vue&type=script&lang=js&"
export * from "./BroadcastStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports